import React, {Component} from 'react';
import Styles from './style.css';
import YieldlockCalculator from "../../components/yieldlock-calculator/component";
import {mapRegister} from "../../services/mapRegister";
import YieldlockCalculatorBuyer from "../../components/yieldlock-calculator-buyer/component";
import YieldlockCalculatorSellToLet from "../../components/yieldlock-calculator-sell-to-let/component";
import YieldlockCalculatorSellToStay from "../../components/yieldlock-calculator-sell-to-stay/component";
import ReactToPdf from 'react-to-pdf';
import queryString from "query-string";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {langRegister} from "../../services/langRegister";
import {BeatLoader} from "react-spinners";
import {Helmet} from "react-helmet";

import PBfaviconAppleTouch from "../../assets/propertybooster-favicon/apple-touch-icon.png";
import PBfavicon32 from "../../assets/propertybooster-favicon/favicon-32x32.png";
import PBfavicon16 from "../../assets/propertybooster-favicon/favicon-16x16.png";
import PBfaviconSiteManifest from "../../assets/propertybooster-favicon/site.webmanifest";
import PBfaviconSiteSafari from "../../assets/propertybooster-favicon/safari-pinned-tab.svg";

import {dataRegister} from "../../services/dataRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

const MyMapComponent = mapRegister.map();

class YieldlockPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            type: '',
            currency: '',
            price: '',
            yield: 0,
            years: 0,
            location: "",
            image: null,
            broker_image: null,
            broker_name: null,
            broker_phone: null,
            broker_email: null,
            broker_show: false,
            lat: 0,
            lng: 0,
            amenities: [],
            loading: true,
            seller_value_relese: 0
        };
    };

    componentWillMount() {
        //window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/pdf/yieldlock');
            ReactGA4.send({ hitType: "pageview", page: "/pdf/yieldlock" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    };

    componentDidMount() {

        let query = queryString.parse(this.props.location.search);
        let upfront = false;

        if (query.up_front) {
            if (query.up_front === "true") {
                upfront = true;
            } else {
                upfront = false;
            }
        } else {
            upfront = false;
        }

        this.setState({
            type: query.type ? query.type : null,
            years: query.years ? query.years : 0,
            yield: query.yield ? query.yield : 0,
            market_rent: query.market_rent ? query.market_rent : 0,
            market_price: query.market_price ? query.market_price : 0,
            list_rent: query.list_rent ? query.list_rent : 0,
            list_price: query.list_price ? query.list_price : 0,
            amenities: query.amenities ? query.amenities : [],
            baths: query.baths ? query.baths : 0,
            beds: query.beds ? query.beds : 0,
            lat: query.lat ? parseFloat(query.lat) : null,
            lng: query.lng ? parseFloat(query.lng) : null,
            property_type: query.property_type ? query.property_type : "",
            property_status: query.property_status ? query.property_status : "",
            industry: query.industry ? query.industry : "",
            location: query.location ? query.location : "",
            sqft: query.sqft ? query.sqft : "",
            image: query.image ? query.image : "",
            currency: query.currency ? query.currency : "",
            broker_image: query.broker_image ? query.broker_image : null,
            broker_phone: query.broker_phone ? query.broker_phone : null,
            broker_email: query.broker_email ? query.broker_email : null,
            broker_name: query.broker_name ? query.broker_name : null,
            up_front: upfront
        }, () => {

            console.log("upfront pdf", this.state.up_front);

            setTimeout(
                function() {
                    this.setState({ loading: false }, () => {
                        window.print();
                    });
                }.bind(this),
                3000
            );
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {}

    scraper = {};

    init = {};

    functions = {};

    renders = {
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        sqm: (value) => {
            try{
                return this.renders.number(Math.round(value * 0.093)) + " sqm";
            }catch (e) {
                return ("...")
            }
        },
    };

    render() {
        return (
            <div className={Styles.container}>
                {
                    this.state.loading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                    </div>
                }
                {
                    <div className={Styles.containerInner}>
                        <div className={Styles.containerInnerLeft}>
                            <img className={Styles.logo}
                                 src={require('../../assets/images/YL_logo_color_signup_2.png')}/>
                            <div className={Styles.containerInnerLeftTitle}>
                                Proposal{" "}
                                {
                                    this.state.type === 'buyer' &&
                                    <span className={Styles.containerInnerLeftTitleBold}>to buyer</span>
                                }
                                {
                                    this.state.type !== 'buyer' &&
                                    <span className={Styles.containerInnerLeftTitleBold}>to seller</span>
                                }
                            </div>
                            {
                                this.state.type === 'buyer' &&
                                <div className={Styles.containerInnerLeftYieldInfo}>
                                    <div>
                                        {this.state.currency}{" "}{this.renders.number(this.state.list_price)}
                                    </div>
                                    {
                                        !this.state.up_front &&
                                    <div>
                                        {this.state.yield}%{" "}Yield assured ({this.state.years}Y)
                                    </div>
                                    }
                                    {
                                        this.state.up_front &&
                                        <div>
                                            {this.state.yield*this.state.years}% ROI Up-front
                                        </div>
                                    }
                                </div>
                            }
                            {
                                this.state.type !== 'buyer' &&
                                <div className={Styles.containerInnerLeftYieldInfo}>
                                    <div>
                                        {this.state.currency}{" "}{this.renders.number(this.state.seller_value_relese)}*
                                    </div>
                                    <div>
                                        {this.state.type}{" "}({this.state.years}Y)
                                    </div>
                                </div>
                            }
                            <div className={Styles.containerInnerLeftYieldInfoDivider}></div>
                            <div className={Styles.containerInnerLeftBox}>
                                <div className={Styles.containerInnerLeftBoxText}>
                                    {
                                        this.state.type === 'buyer' &&
                                        <span>Yield term{" "}:</span>
                                    }
                                    {
                                        this.state.type !== 'buyer' &&
                                        <span>Lease term{" "}:</span>
                                    }
                                    {" "}
                                    <span
                                        className={Styles.containerInnerLeftBoxTextBold}>{this.state.years}{" Years"}</span>
                                </div>
                            </div>
                            <div className={Styles.containerInnerLeftBox}>
                                {
                                    this.state.type === 'buyer' &&
                                    <div className={Styles.containerInnerLeftBoxText}>
                                        Gross yield{" "}:
                                        {" "}
                                        <span
                                            className={Styles.containerInnerLeftBoxTextBold}>{this.state.yield}{" %"}</span>
                                    </div>
                                }
                                {
                                    this.state.type !== 'buyer' &&
                                    <div className={Styles.containerInnerLeftBoxText}>
                                        {((this.state.list_rent === this.state.market_rent) || !this.state.list_rent) &&
                                            <span>Market rent (long-term)</span>
                                        }
                                        {(this.state.list_rent && this.state.list_rent !== this.state.market_rent) &&
                                            <span>Market rent (short-term)</span>
                                        }
                                        {" "}:
                                        {" "}
                                        <span className={Styles.containerInnerLeftBoxTextBold}>{this.renders.number(this.state.list_rent)}{" "}{this.state.currency}*</span>
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerLeftBox}>
                                {
                                    this.state.type === 'buyer' && this.state.list_price >= this.state.market_price &&
                                    <div className={Styles.containerInnerLeftBoxText}>
                                        List price{" "}:
                                        {" "}
                                        <span
                                            className={Styles.containerInnerLeftBoxTextBold}>{this.renders.number(this.state.list_price)}{" "}{this.state.currency}</span>
                                    </div>
                                }
                                {
                                    this.state.type === 'buyer' && this.state.list_price < this.state.market_price &&
                                    <div className={Styles.containerInnerLeftBoxText}>
                                        Market price{" "}:
                                        {" "}
                                        <span
                                            className={Styles.containerInnerLeftBoxTextBold}>{this.renders.number(this.state.market_price)}{" "}{this.state.currency}</span>
                                    </div>
                                }
                                {
                                    this.state.type !== 'buyer' &&
                                    <div className={Styles.containerInnerLeftBoxText}>
                                        Market price{" "}:
                                        {" "}
                                        <span className={Styles.containerInnerLeftBoxTextBold}>{this.renders.number(this.state.market_price)}{" "}{this.state.currency}</span>
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerLeftArrow}>
                                <img className={Styles.containerInnerLeftArrowItem}
                                     src={require('../../assets/images/AB_arrow_down_orange.png')}/>
                            </div>
                            {
                                <div className={Styles.containerInnerLeftCalculator}>
                                    {
                                        this.state.type === 'buyer' &&
                                        <YieldlockCalculatorBuyer
                                            years={this.state.years}
                                            list_rent={this.state.list_rent}
                                            market_price={this.state.market_price}
                                            market_rent={this.state.market_rent}
                                            list_price={this.state.list_price}
                                            yield={this.state.yield}
                                            up_front={this.state.up_front}
                                        />
                                    }
                                    {
                                        this.state.type === 'sell-to-let' && this.state.type !== 'buyer' &&
                                        <YieldlockCalculatorSellToLet
                                            years={this.state.years}
                                            list_rent={this.state.list_rent}
                                            market_price={this.state.market_price}
                                            market_rent={this.state.market_rent}
                                            list_price={this.state.list_price}
                                            yield={this.state.yield}
                                            up_front={this.state.up_front}
                                            sellerValueRelese={(value) => {
                                                this.setState({
                                                    seller_value_relese: value
                                                })
                                            }}
                                        />
                                    }
                                    {
                                        this.state.type === 'sell-to-let' && this.state.type === 'buyer' &&
                                        <YieldlockCalculatorSellToLet
                                            years={this.state.years}
                                            list_rent={this.state.list_rent}
                                            market_price={this.state.market_price}
                                            market_rent={this.state.market_rent}
                                            list_price={this.state.list_price}
                                            yield={this.state.yield}
                                            up_front={this.state.up_front}
                                            buyer={true}
                                        />
                                    }
                                    {
                                        this.state.type === 'sell-to-stay' &&
                                        <YieldlockCalculatorSellToStay
                                            years={this.state.years}
                                            list_rent={this.state.list_rent}
                                            market_price={this.state.market_price}
                                            market_rent={this.state.market_rent}
                                            list_price={this.state.list_price}
                                            yield={this.state.yield}
                                            up_front={this.state.up_front}
                                            sellerValueRelese={(value) => {
                                                this.setState({
                                                    seller_value_relese: value
                                                })
                                            }}
                                        />
                                    }
                                </div>
                            }
                            <div className={Styles.containerInnerLeftFaqTitle}>
                                Any{" "}
                                <span className={Styles.containerInnerLeftFaqTitleBold}>
                                    questions?
                                </span>
                            </div>
                            {
                                this.state.type === 'buyer' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Do I own the property?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        Yes, you are the legal owner of the property both during and past the yield term,
                                        why you are also entitled to any value increase if you chose to sell
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'buyer' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Is my yield secure?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        Your yield is considered to be one of the safest on the market, all your yield is
                                        banked up-front into an A+ grade deposit meaning assured future payouts
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'buyer' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Can I sell the property?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        Yes, you can at any time request to sell the property, any remaining yield will be
                                        transferred to the new buyer
                                    </div>
                                </div>
                            }

                            {
                                this.state.type === 'sell-to-let' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Are my rental incomes secured?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        As with any rentals you influence your rental income, consult your dedicated
                                        agent to get the most out of your rental
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'sell-to-let' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Can I let short-term?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        Yes, you can let short-term and long-term subject to your community rules,
                                        consult our certified agents to know more
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'sell-to-let' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Can I buy back my property?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        You can always make an offer to buy back your property towards the end of
                                        your lease
                                    </div>
                                </div>
                            }

                            {
                                this.state.type === 'sell-to-stay' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Do I have to pay rent?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        Your rent is deducted from your up-front equity keeping you protected from
                                        rental increase during the lease term
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'sell-to-stay' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Can I stay past the lease term?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        You can only stay during the lease term, however you can make an offer to
                                        extend your lease towards the end of your lease
                                    </div>
                                </div>
                            }
                            {
                                this.state.type === 'sell-to-stay' &&
                                <div className={Styles.containerInnerLeftFaqItem}>
                                    <div className={Styles.containerInnerLeftFaqItemTitle}>
                                        Can I buy back my property?
                                    </div>
                                    <div className={Styles.containerInnerLeftFaqItemText}>
                                        You can always make an offer to buy back your property towards the end of
                                        your lease
                                    </div>
                                </div>
                            }

                            <div className={Styles.containerInnerLeftSpace}/>
                            <div className={Styles.containerInnerLeftDisclaimer}>
                                <div className={Styles.containerInnerLeftDisclaimerTitle}>
                                    DISCLAIMER
                                </div>
                                <div className={Styles.containerInnerLeftDisclaimerText}>
                                    This material only constitute information about the YIELDLOCK framework and should
                                    not be seen as
                                    financial advice. Prior to a contracting decision, you should always consult
                                    professional guidance via a
                                    YIELDLOCK certified agent.*All projections provided are indicative and fees excl
                                </div>
                            </div>
                        </div>
                        <div className={Styles.containerInnerCenter}>

                        </div>
                        <div className={Styles.containerInnerRight}>
                            <div className={Styles.containerInnerRightTop}>
                                {
                                    this.state.type === 'buyer' &&
                                    <div className={Styles.containerInnerRightTopUrl}>
                                        yieldspotter.com/buy
                                    </div>
                                }
                                {
                                    this.state.type !== 'buyer' &&
                                    <div className={Styles.containerInnerRightTopUrl}>
                                        yieldspotter.com/sell
                                    </div>
                                }
                                <div className={Styles.containerInnerRightTopBroker}>
                                    <div style={!this.state.broker_image?{textAlign: "right"}:{}} className={Styles.containerInnerRightTopBrokerInfo}>
                                        <div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoTitle}>
                                                Certified Agent
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoName}>
                                                {this.state.broker_name}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoEmail}>
                                                {this.state.broker_email}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoPhone}>
                                                {this.state.broker_phone}
                                            </div>
                                            <div className={Styles.containerInnerRightTopBrokerInfoButtons}>
                                                <a href={"tel:" + this.state.broker_phone}>
                                                    <div className={Styles.containerInnerRightTopBrokerInfoButtonsItem}>
                                                        <img style={{width: '12px'}}
                                                             src={require('../../assets/images/phone_icon_white.png')}/>
                                                    </div>
                                                </a>
                                                <a href={"https://wa.me/" + this.state.broker_phone + "/?text=Hey"}>
                                                    <div className={Styles.containerInnerRightTopBrokerInfoButtonsItem}>
                                                        <img style={{width: '11px'}}
                                                             src={require('../../assets/images/whatsapp_white.png')}/>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.broker_image &&
                                        <div style={{backgroundImage: 'url(' + this.state.broker_image + ')'}} className={Styles.containerInnerRightTopBrokerImage}></div>
                                    }
                                </div>
                            </div>
                            <div
                                className={Styles.containerInnerRightProperty}>
                                {
                                    this.state.location &&
                                    <div className={Styles.containerInnerRightPropertyLocation}>
                                        {this.state.location}
                                    </div>
                                }
                                <div className={Styles.containerInnerRightPropertyName}>
                                    {this.state.industry}
                                </div>
                            </div>
                            <div style={{backgroundImage: 'url(' + this.state.image + ')'}} className={Styles.containerInnerRightPropertyImage}>
                                {
                                    !this.state.up_front && this.state.type === 'buyer' && (this.state.market_price > this.state.list_price) && ((100 -((this.state.list_price/this.state.market_price)*100))> 3) &&
                                    <div className={Styles.containerInnerRightPropertyImagetriangle}></div>
                                }
                                {
                                    !this.state.up_front && this.state.type === 'buyer' && (this.state.market_price > this.state.list_price) && ((100 -((this.state.list_price/this.state.market_price)*100))> 3) &&
                                    <div className={Styles.containerInnerRightPropertyImageBadge}>
                                        {Math.round((100 -((this.state.list_price/this.state.market_price)*100)))}% below market
                                    </div>
                                }
                                {
                                    this.state.up_front && this.state.type === 'buyer' &&
                                    <div className={Styles.containerInnerRightPropertyImagetriangle}></div>
                                }
                                {
                                    this.state.up_front && this.state.type === 'buyer' &&
                                    <div className={Styles.containerInnerRightPropertyImageBadge}>
                                        {this.state.yield*this.state.years}% ROI Up-front
                                    </div>
                                }
                                {
                                    this.state.type !== 'buyer' && (this.state.seller_value_relese > this.state.market_price) && ((100 -((this.state.market_price/this.state.seller_value_relese)*100))> 2) &&
                                    <div className={Styles.containerInnerRightPropertyImagetriangle}></div>
                                }
                                {
                                    this.state.type !== 'buyer' && (this.state.seller_value_relese > this.state.market_price) && ((100 -((this.state.market_price/this.state.seller_value_relese)*100))> 2) &&
                                    <div className={Styles.containerInnerRightPropertyImageBadge}>
                                        {Math.round((100 -((this.state.market_price/this.state.seller_value_relese)*100)))}% value boost
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerRightPropertyAmenities}>
                                <div className={Styles.containerInnerRightPropertyAmenitiesLeft}>
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.state.beds}{this.state.beds > 1 ? " Beds" : " Bed"}{" "}{this.state.property_type}{" "}|{" "}{this.state.property_status}
                                    </div>
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.state.baths}{" "}{this.state.baths > 1 ? " Bathrooms" : " Bathroom"}
                                    </div>
                                    {this.state.sqft && this.state.sqft > 0 &&
                                    <div className={Styles.containerInnerRightPropertyAmenitiesLeftItem}>
                                        {this.renders.number(this.state.sqft)}{" "}sqft | {this.renders.sqm(this.state.sqft)}
                                    </div>
                                    }
                                </div>
                                {
                                    Array.isArray(this.state.amenities) &&
                                    <div className={Styles.containerInnerRightPropertyAmenitiesRight}>
                                        {
                                            this.state.amenities.filter((item, index) => {
                                                return index < 3
                                            }).map((item) => {
                                                return (
                                                    <div
                                                        className={Styles.containerInnerRightPropertyAmenitiesRightItem}>
                                                        <div
                                                            className={Styles.containerInnerRightPropertyAmenitiesRightItemText}>
                                                            {item}
                                                        </div>
                                                        {
                                                            <div className={Styles.containerInnerRightPropertyAmenitiesRightItemCheckmark}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="10px" viewBox="0 0 25 20">
                                                                    <polyline fill="none" stroke={"#00273A"} stroke-width="4.5" stroke-miterlimit="10" points="2.5,9.133 8.915,15.602 22.541,2 "/>
                                                                </svg>
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                            <div className={Styles.containerInnerRightPropertyMap}>
                                {
                                    this.state.lat && this.state.lng &&
                                    <MyMapComponent
                                        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyCNIJwUJ8ggv72a2YwgF8HSLUDj6BYqAv8&v=3.56&libraries=geometry,drawing,places"
                                        loadingElement={<div style={{height: `100%`}}/>}
                                        containerElement={<div className={Styles.containerContentMap}/>}
                                        mapElement={<div style={{height: `100%`}}/>}
                                        lat={this.state.lat}
                                        lng={this.state.lng}
                                    />
                                }
                            </div>
                            <div className={Styles.containerInnerLeftSpace}/>
                            <div className={Styles.containerInnerRightPropertyImages}>
                                <div className={Styles.containerInnerRightPropertyImagesBanners}>
                                    <img className={Styles.containerInnerRightPropertyImagesBannersItem}
                                         src={require('../../assets/images/YS_badgeCertified.png')}/>
                                    <img className={Styles.containerInnerRightPropertyImagesBannersItem}
                                         src={require('../../assets/images/YS_badgeInnovator.png')}/>
                                </div>
                                <div className={Styles.containerInnerRightPropertyImagesRoisec}>
                                    <img className={Styles.containerInnerRightPropertyImagesRoisecItem}
                                         src={require('../../assets/images/ROISEC_Logotype_RGB.png')}/>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default YieldlockPdf;


// WEBPACK FOOTER //
// ./src/pages/yieldlock-pdf/component.js